export enum DealState {
  DRAFT = 'draft',
  CLOSE = 'close',
  ACTIVE = 'active',
  AMENDING = 'amending',
  ENDING = 'ending',
}

export enum DealKind {
  OTHER_OR_UNKNOWN = 'other_or_unknown',
  DM_PLUS = 'dm_plus',
  DM_BASIC = 'dm_basic',
  MINI_DEAL = 'mini_deal',
  REG_CF = 'reg_cf',
  REG_A = 'reg_a',
  WARRANTS = 'warrants',
  OM = 'offering_memorandum',
  REG_D_506_C = 'reg_d_506_c',
  REG_D_506_B = 'reg_d_506_b',
  REG_S = 'reg_s',
}

export interface DealIssuer {
  id: number;
  name: string;
  logo: string | null;
}

export interface DealEnterprise {
  id: number;
  name: string;
}

export interface DealInvestorMetrics {
  total: number;
  draft: number;
  invited: number;
  signed: number;
  waiting: number;
  accepted: number;
}

export interface DealFundingMetrics {
  amount_subscribed: number;
  funds_received: number;
  funds_pending: number;
  securities_subscribed: number;
  amount_allocated: number;
  securities_allocated: number;
  amount_accepted: number;
  securities_accepted: number;
}

export interface Deal {
  id: number;
  title: string;
  state: DealState;
  currency: string;
  security_type: string;
  price_per_security: number;
  minimum_investment: number;
  maximum_investment: number;
  issuer: DealIssuer;
  enterprise: DealEnterprise;
  deal_type: DealKind;
  investors: DealInvestorMetrics;
  funding?: DealFundingMetrics;
  maximum_free_shares: number | null;
  allow_existing_free_shares: boolean;
  maximum_discount_percentage: number;
}
